(() => {
  if (window.tcUiPolishLoaded) return;
  window.tcUiPolishLoaded = true;
  document.addEventListener('input', event => {
    if (!event.target.matches('.tc-country-search')) return;
    const query = event.target.value.trim().toLocaleLowerCase();
    event.target.nextElementSibling.querySelectorAll('.disclosure__item').forEach(item => {
      const link = item.querySelector('[data-value]');
      item.hidden = !`${item.textContent} ${link?.dataset.value || ''}`.toLocaleLowerCase().includes(query);
    });
  });
  // Quick add: the stars and the review count under the title open the reviews right below them
  // (the full Judge.me widget is in the popup but hidden, so its own click had nowhere to go)
  const QA_TEXT = {
    en: ['Verified buyer', 'Read all reviews'],
    it: ['Acquirente verificato', 'Leggi tutte le recensioni'],
    de: ['Verifizierter Käufer', 'Alle Bewertungen lesen'],
    fr: ['Acheteur vérifié', 'Lire tous les avis'],
  };
  const esc = text => String(text).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  document.addEventListener('click', event => {
    const badge = event.target.closest?.('quick-add-modal .jdgm-prev-badge');
    if (!badge) return;
    event.preventDefault();
    event.stopPropagation();
    const modal = badge.closest('quick-add-modal');
    const host = badge.closest('.shopify-block') || badge.parentElement;
    let panel = host.nextElementSibling?.classList.contains('tc-qa-reviews') ? host.nextElementSibling : null;
    if (!panel) {
      const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
      const [verified, all] = QA_TEXT[lang] || QA_TEXT.en;
      const reviews = [...modal.querySelectorAll('.jdgm-rev')].slice(0, 3);
      const url = reviews[0]?.dataset.productUrl || modal.querySelector('a.product__view-details')?.getAttribute('href') || '';
      const date = value => {
        const d = new Date(String(value || '').replace(' UTC', 'Z').replace(' ', 'T'));
        return isNaN(d) ? '' : d.toLocaleDateString(document.documentElement.lang || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
      };
      const cards = reviews.map(review => {
        const score = Math.max(0, Math.min(5, Math.round(parseFloat(review.querySelector('.jdgm-rev__rating')?.dataset.score || '5'))));
        const title = review.querySelector('.jdgm-rev__title')?.textContent.trim() || '';
        const body = review.querySelector('.jdgm-rev__body')?.textContent.trim() || '';
        const author = review.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
        const when = date(review.querySelector('.jdgm-rev__timestamp')?.dataset.content);
        return `<article class="tc-qa-review"><div class="tc-qa-review__top"><span class="tc-qa-review__stars" role="img" aria-label="${score}/5">${'★'.repeat(score)}<span>${'★'.repeat(5 - score)}</span></span>${when ? `<time>${esc(when)}</time>` : ''}</div>`
          + (title ? `<p class="tc-qa-review__title">${esc(title)}</p>` : '') + (body ? `<p class="tc-qa-review__body">${esc(body)}</p>` : '')
          + `<p class="tc-qa-review__author">${esc(author)}${review.dataset.verifiedBuyer === 'true' ? ` <span>· ${esc(verified)}</span>` : ''}</p></article>`;
      }).join('');
      panel = document.createElement('div');
      panel.className = 'tc-qa-reviews';
      panel.innerHTML = `<div class="tc-qa-reviews__inner">${cards}${url ? `<a class="tc-qa-reviews__all" href="${esc(url)}#tc-reviews">${esc(all)} →</a>` : ''}</div>`;
      host.after(panel);
      void panel.offsetHeight;
    }
    const open = !badge.classList.contains('tc-qa-open');
    badge.classList.toggle('tc-qa-open', open);
    panel.classList.toggle('is-open', open);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.target.matches('.tc-country-search') && event.key === 'Enter') event.preventDefault();
    const modal = document.querySelector('#login-modal__window.login-modal-active');
    if (!modal) return;
    if (event.key === 'Escape') {
      modal.classList.remove('login-modal-active');
      document.querySelector('.header__icon--account')?.focus();
    }
    if (event.key === 'Tab') {
      const controls = [...modal.querySelectorAll('button,input:not([type=hidden]),a[href]')].filter(e => e.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('click', event => {
    const account = event.target.closest('.header__icon--account');
    if (account) {
      event.preventDefault();
      requestAnimationFrame(() => document.querySelector('#login-modal__window.login-modal-active input[type=email]')?.focus());
    }
  });
  // Reviews (Judge.me): the app leaves its write button in English in French and German, and speaks German with "Sie"
  // while the shop says "du". The few lines on show follow the shop's language and tone.
  const JDGM_TEXT = {
    fr: { '.jdgm-write-rev-link': 'Écrire un avis' },
    de: { '.jdgm-write-rev-link': 'Bewertung schreiben', '.jdgm-rev-widg__summary-text': [/^Schreiben Sie die erste Bewertung$/, 'Schreib die erste Bewertung'] },
  }[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()];
  if (JDGM_TEXT) {
    const fixReviews = () => Object.entries(JDGM_TEXT).forEach(([sel, val]) => document.querySelectorAll(sel).forEach(el => {
      const now = el.textContent.trim();
      if (Array.isArray(val)) { if (val[0].test(now)) el.textContent = val[1]; }
      else if (now && now !== val && /^write a review$/i.test(now)) el.textContent = val;
    }));
    let pending = 0;
    new MutationObserver(() => { if (!pending) pending = requestAnimationFrame(() => { pending = 0; fixReviews(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
    fixReviews();
  }
})();

// ---------- product description: the numbered steps become a gold thread that runs down and lights each step in turn ----------
(() => {
  const lists = [...document.querySelectorAll('.tc-pdp-details__body ol')].filter((ol) => ol.querySelectorAll(':scope > li').length > 1);
  if (!lists.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DUR = 1.6;
  // the thread runs from the first step's dot to the last one, wherever the last step wraps
  const measure = (ol) => {
    const items = ol.querySelectorAll(':scope > li');
    const first = items[0], last = items[items.length - 1];
    const center = (li) => parseFloat(getComputedStyle(li).fontSize) * 0.875;
    ol.style.setProperty('--tc-steps-top', (first.offsetTop + center(first)) + 'px');
    ol.style.setProperty('--tc-steps-bottom', Math.max(0, ol.clientHeight - last.offsetTop - center(last)) + 'px');
  };
  const io = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.35 })
    : null;
  lists.forEach((ol) => {
    const items = ol.querySelectorAll(':scope > li');
    ol.classList.add('tc-steps');
    ol.setAttribute('role', 'list'); // Safari drops the list semantics once the numbers are hidden
    items.forEach((li, i) => li.style.setProperty('--i', i));
    ol.style.setProperty('--tc-steps-dur', DUR + 's');
    ol.style.setProperty('--tc-steps-step', (DUR / (items.length - 1)).toFixed(3) + 's');
    measure(ol);
    if (!io) return;
    const r = ol.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0) return; // already on screen: shown finished, never hidden first
    ol.classList.add('is-armed');
    io.observe(ol);
  });
  let t;
  addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => lists.forEach(measure), 150); });
})();

/* ---------- Treasure Club card (snippets/tc-club-popup): the newsletter with the 10% welcome gift ----------
   Opens once the visitor has spent 25 s on the site, or has scrolled past the middle of a page after at least 8 s;
   waits while the cookie banner, a drawer, the search, the quick add, the sign-in panel or the five layers' captions
   are on screen, and while the home's own newsletter form is in view. Closed: back after three weeks. Joined: never
   again. After a sign-up sent from the card it opens again on the reloaded page to show the thanks (or the error).
   The card can bring its own storage key and wait (data-key, data-latest: the Halloween special opens after 6 s), and
   any element marked data-tc-club-wait keeps it closed while on screen, like the home's newsletter. */
(() => {
  const root = document.getElementById('tc-club');
  if (!root) return;
  const KEY = root.dataset.key || 'tc-club', COOL = 21 * 864e5, LATEST = Number(root.dataset.latest) || 25000, EARLIEST = Math.min(8000, LATEST), DEPTH = .55;
  const store = (session) => { try { return session ? sessionStorage : localStorage; } catch (e) { return null; } };
  const get = (k, s) => { try { return store(s).getItem(k); } catch (e) { return null; } };
  const set = (k, v, s) => { try { store(s).setItem(k, v); } catch (e) {} };
  const del = (k, s) => { try { store(s).removeItem(k); } catch (e) {} };
  const html = document.documentElement;
  const state = (root.querySelector('.tc-club__state') || { dataset: {} }).dataset.state || 'idle';
  const fromCard = get('tc-club-posted', true) === '1';
  del('tc-club-posted', true);
  if (state === 'joined') set(KEY, 'joined');
  const preview = new URLSearchParams(location.search).get('tc_club') === 'now';

  const shown = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > .05 && el.getClientRects().length > 0;
  };
  const busy = () => {
    if (html.classList.contains('tc-asm-immersive')) return true;
    const cky = document.querySelector('.cky-consent-container');
    if (cky && !cky.classList.contains('cky-hide') && shown(cky)) return true;
    if (document.querySelector('cart-drawer.active, quick-add-modal[open], .menu-drawer-container[open], #dT_top-sticky.search-show, product-modal[open]')) return true;
    if (shown(document.getElementById('login-modal__window'))) return true;
    // never over the product page's sticky add-to-cart bar: there the visitor is buying
    const sticky = document.getElementById('sticky-bar-form');
    if (sticky && shown(sticky)) { const r = sticky.getBoundingClientRect(); if (r.height > 0 && r.top < innerHeight && r.bottom > 0) return true; }
    for (const club of document.querySelectorAll('.tc-home__newsletter, [data-tc-club-wait]')) { const r = club.getBoundingClientRect(); if (r.height > 0 && r.top < innerHeight && r.bottom > 0) return true; }
    return false;
  };

  let opened = false;
  const open = () => {
    if (opened) return;
    opened = true;
    root.hidden = false;
    void root.offsetWidth; // lay the card out in its start pose first, so it rises in (no frame callbacks: they wait for a visible tab)
    root.classList.add('is-open');
    html.classList.add('tc-club-open');
  };
  const close = () => {
    root.classList.remove('is-open');
    html.classList.remove('tc-club-open');
    if (get(KEY) !== 'joined') set(KEY, String(Date.now()));
    setTimeout(() => { root.hidden = true; }, 500);
  };
  root.querySelector('.tc-club__close').addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  const form = root.querySelector('form');
  if (form) form.addEventListener('submit', () => set('tc-club-posted', '1', true));

  if (fromCard && state !== 'idle') { open(); return; }
  if (!preview) {
    const saved = get(KEY);
    if (saved === 'joined' || (saved && Date.now() - Number(saved) < COOL)) return;
  }

  const start = performance.now();
  let armed = false;
  const tryOpen = () => {
    if (opened) return;
    if (busy()) { setTimeout(tryOpen, 2000); return; }
    open();
  };
  const arm = () => { if (armed) return; armed = true; removeEventListener('scroll', onScroll); tryOpen(); };
  const onScroll = () => {
    const max = html.scrollHeight - innerHeight;
    if (max > 0 && scrollY / max >= DEPTH && performance.now() - start >= EARLIEST) arm();
  };
  if (preview) { setTimeout(arm, 1200); return; }
  addEventListener('scroll', onScroll, { passive: true });
  setTimeout(arm, LATEST);
})();
